<template>
    <span>
        <button
            v-if="type === 'releaseBuyGroups'"
            class="btn btn-sm btn-danger"
            type="button"
            @click="openModal()"
        >
             <i class="fa fa-ban"></i>
            <span class="sr-only">Release</span>
        </button>
        <button
            v-if="type === 'releaseFiles'"
            class="btn btn-sm btn-danger"
            type="button"
            @click="openModal()"
        >
             <i class="fa fa-ban"></i>
            <span class="sr-only">Release</span>
        </button>
    </span>
</template>

<script>
export default {
    data() {
        return {
            modal: {
                'class': 'modal-lists',
                'header': '',
                'body': '',
                'isBodyHtml': true,
                'id': '',
                'active': '',
            }
        }
    },
    props: {
        'id': Number,
        'type': String,
        'route': Object,
    },
    methods: {
        click: function () {
            this.emitModalData();
            return this.$emit('click');
        },
        emitModalData: function () {
            return this.$emit('modalEmitData', this.modal);
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        openModal: function () {
            this.click();
            this.modal = this[this.type]();
            this.emitModalData();
        },
        releaseBuyGroups() {
            return {
                header: 'Release SourceNumbers Group #' + this.id,
                bodyHeader: '',
                body: 'Confirm the SourceNumbers Group releasing please.',
                btnColor: 'btn-danger',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: 'Release',
                denyText: 'Close',
                method: 'POST',
            }
        },
        releaseFiles() {
            return {
                header: 'Release SourceNumbers File #' + this.id,
                bodyHeader: '',
                body: 'Confirm the SourceNumbers File releasing please.',
                btnColor: 'btn-danger',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: 'Release',
                denyText: 'Close',
                method: 'GET',
            }
        },
    }
}
</script>
